export default (fileName: string) => fileName.toLocaleLowerCase().split('.').pop();
